import {AdBannerEventType} from '@core-client/ads/banner/AdBannerEventType';
import {log} from '../util/BannerCommon';

import type {IBannerHookSettings} from './BaseBannerHook';
import {BannerWithOptionsHook} from './BannerWithOptionsHook';
import type {IBannerJson} from './IBannerJson';

export class FullScreenBannerHook extends BannerWithOptionsHook {
    private bodyOverflow: string = '';

    constructor(settings: IBannerHookSettings<IBannerJson>) {
        log('FullScreenBannerHook init');
        super(settings);
    }

    override activate() {
        const elem = this.element;
        super.activate();
        this.listenAdLoaded();
        elem.addEventListener(AdBannerEventType.adStart, this.onAdStarted);
        elem.addEventListener(AdBannerEventType.adClosed, this.onAdClosed);
        // Баннер от Яндекса может скрывать полосу прокрутки документа.
        // Запоминаем значение overflow, чтобы восстановить его при автоскрытии баннера.
        if (document.body) {
            this.bodyOverflow = document.body.style.overflow;
        }
    }

    override deactivate() {
        const elem = this.element;
        if (document.body) {
            document.body.style.overflow = this.bodyOverflow;
        }
        elem.classList.remove('__show');
        this.unlistenAdLoaded();
        elem.removeEventListener(AdBannerEventType.adStart, this.onAdStarted);
        elem.removeEventListener(AdBannerEventType.adClosed, this.onAdClosed);
        super.deactivate();
    }

    override getAdLoadEventList() {
        return [AdBannerEventType.adLoaded, AdBannerEventType.rbAdInfo];
    }

    private doHandleAdLoad() {
        // Баннер от Яндекса встраивается не в наш контейнер, а в конец страницы.
        // В этом случае не надо показывать подложку, поскольку у баннера она есть и нет возможности отследить его закрытие.
        if (!this.getDirectBannerNode()) {
            this.element.classList.add('__show');
        }
        clearTimeout(this.adWaitTimeoutId);
        this.scheduleAutoClose();
    }

    override handleAdLoaded() {
        this.doHandleAdLoad();
        super.handleAdLoaded();
    }

    onAdStarted = () => {
        this.doHandleAdLoad();
    };
}
